import { CONSTANTS } from 'services/constants';
import HomePage from 'components/Components/Pages/HomePage';
import DestinationsPage from 'components/Components/Pages/DestinationsPage/Loadable';
import HotelsPage from 'components/Components/Pages/HotelsPage/Loadable';
import HotelPage from 'components/Components/Pages/HotelPage';
import DestinationPage from 'components/Components/Pages/DestinationPage';
import FaqPage from 'components/Components/Pages/FaqPage/Loadable';
import AboutUsPage from 'components/Components/Pages/AboutUsPage/Loadable';
import PrivacyPolicyPage from 'components/Components/Pages/PrivacyPolicyPage/Loadable';
import ContactUsThankYouPage from 'components/Components/Pages/ContactUsThankYouPage/Loadable';
import QuoteThankYouPage from 'components/Components/Pages/QuoteThankYouPage/Loadable';
import ContactUsPage from 'components/Components/Pages/ContactUsPage/Loadable';
import NotFoundPage from 'components/Components/Pages/NotFoundPage/Loadable';
import SharedRoutePage from 'components/Components/Pages/SharedRoutePage';
import ClusterPage from "components/Components/Pages/ClusterPage";

export const routes = {
    homePage: {
        path: CONSTANTS.ROUTING.HOME_PAGE,
        name: 'home-page',
        component: HomePage,
        private: false,
    },
    destinationsPage: {
        path: CONSTANTS.ROUTING.DESTINATIONS_PAGE,
        name: 'destinations-page',
        component: DestinationsPage,
        private: false,
    },
    hotelsPage: {
        path: CONSTANTS.ROUTING.HOTELS_PAGE,
        name: 'hotels-page',
        component: HotelsPage,
        private: false,
    },
    sharedPage: {
        path: CONSTANTS.ROUTING.SHARED_ROUTE,
        name: 'shared-page',
        component: SharedRoutePage,
        exact: true,
        private: false,
    },
    hotelWithDestinationParentPage: {
        path: CONSTANTS.ROUTING.HOTEL_WITH_DESTINATION_PARENT_PAGE,
        name: 'hotel-with-destination-parent-page',
        component: HotelPage,
        exact: true,
        private: false,
    },
    hotelRoomPage: {
        path: CONSTANTS.ROUTING.HOTEL_ROOM_PAGE,
        name: 'hotel-room-page',
        component: HotelPage,

        private: false,
    },
    ClusterPage: {
        path: CONSTANTS.ROUTING.CLUSTER_PAGE,
        name: 'cluster-page',
        component: ClusterPage,

        private: false,
    },
    hotelRoomWithDestinationParentPage: {
        path: CONSTANTS.ROUTING.HOTEL_ROOM_WITH_DESTINATION_PARENT_PAGE,
        name: 'hotel-room-with-destination-parent-page',
        component: HotelPage,

        private: false,
    },
    hotelClusterWithDestinationParentPage: {
        path: CONSTANTS.ROUTING.HOTEL_CLUSTER_WITH_DESTINATION_PARENT_PAGE,
        name: 'hotel-cluster-with-destination-parent-page',
        component: ClusterPage,

        private: false,
    },
    destinationPage: {
        path: CONSTANTS.ROUTING.DESTINATION_PAGE,
        name: 'destination-page',
        component: DestinationPage,
        private: false,
    },
    faqPage: {
        path: CONSTANTS.ROUTING.FAQ_PAGE,
        name: 'faq-page',
        component: FaqPage,
        private: false,
    },
    aboutUsPage: {
        path: CONSTANTS.ROUTING.ABOUT_US_PAGE,
        name: 'about-us-page',
        component: AboutUsPage,
        private: false,
    },
    privacyPolicyPage: {
        path: CONSTANTS.ROUTING.PRIVACY_POLICY_PAGE,
        name: 'privacy-policy-page',
        component: PrivacyPolicyPage,
        private: false,
    },
    contactUsThankYouPage: {
        path: CONSTANTS.ROUTING.CONTACT_US_THANK_YOU_PAGE,
        name: 'contact-us-thank-you-page',
        component: ContactUsThankYouPage,
        private: false,
    },
    quoteThankYouPage: {
        path: CONSTANTS.ROUTING.QUOTE_THANK_YOU_PAGE,
        name: 'quote-thank-you-page',
        component: QuoteThankYouPage,
        private: false,
    },
    contactUsPage: {
        path: CONSTANTS.ROUTING.CONTACT_US_PAGE,
        name: 'contact-us-page',
        component: ContactUsPage,
        private: false,
    },
    notFoundPage: {
        path: '*',
        name: 'notFoundPage',
        component: NotFoundPage,
    },
    /*
    regionPage: {
        path: CONSTANTS.ROUTING.REGION_PAGE,
        name: 'region-page',
        component: RegionPage,
        private: false,
    },
    quotePage: {
        path: CONSTANTS.ROUTING.QUOTE_PAGE,
        name: 'quote-page',
        component: QuotePage,
        private: false,
    },
    unauthorized: {
        path: '/app/401',
        name: 'unauthorized',
        component: UnauthorizedPage,
    },
    InternshipPage: {
        path: CONSTANTS.ROUTING.INTERNSHIP_PAGE,
        name: 'internship-page',
        component: InternshipPage,

        private: false,
    },
    */
};
